;(function () {
  'use strict'

  angular
    .module('contrast.onboarding.tutorial')
    .constant('onboardingTutorialConstants', {
      TUTORIAL_TYPE: {
        APPLICATIONS: 'APPLICATIONS',
        APP_OVERVIEW: 'APP_OVERVIEW',
        APP_LIBRARIES: 'APP_LIBRARIES',
        APP_VULNERABILITIES: 'APP_VULNERABILITIES',
        ATTACKS: 'ATTACKS'
      }
    })
})()
